import React, { useState } from "react";
import { makeStyles } from "tss-react/mui";
import "../FilterGroupNew.js";
import { useDateRangeFilter } from "./hooks.js";
import "./DateRangeFilter.js";
import "../date-filter/DateFilter.js";
import "../TextFilterWithDropdown.js";
import "../MultiStepFilterDrawer.js";
import "../../select/Select.js";
import "../TextFilter.js";
import "../valueRangeFilter/ValueRangeFilter.js";
import { formatDateRange, getTodayAsDate, timestampSecondsToDate } from "../../../utils/date.js";
import "react-intl";
import { localized } from "./localized.js";
import "./DateRangeHistoricalFilter.js";
import { MultiStepFilterApplyButton } from "../MultiStepFilterApplyButton.js";
import { MultiStepFilterInput } from "../MultiStepFilterInput.js";
import { withMultiStepFilterHoc } from "../MultiStepFilterHoc.js";
import "@mui/material";
import "../../chip/ChipRenderer.js";
import "../../select/selectStyle.js";
import "../../select/MultiSelectFooter.js";
import "../../select/MultiSelect.js";
import "../../select/MultiSelectItem.js";
import "../../select/SelectArrowIcon.js";
import "../../select/VirtualizedMultiSelectOptionList.js";
import "../../select/SingleSelect.js";
import "../../select/MultiSelectWithExclude.js";
import "../../select/MultiSelectTextCounterWithTooltip.js";
import "../PhoneFilter.js";
import "../../input/validation.js";
import "../../input/DatePicker.js";
import { DateRangePicker } from "../../input/DateRangePicker.js";
import "../../input/StyledInput.js";
import "../../input/FormInput.js";
import "../../input/StyledFormInputHoc.js";
import "../../input/DateSinglePicker.localize.js";
import "moment-timezone";
import { useYearsAndMonthsOptions } from "../../input/hooks.js";
import { RadioGroupList } from "../../input/RadioGroupList.js";
const useClasses = makeStyles()((theme) => ({
  multiStepDatePickerCaption: {
    display: "grid",
    gridTemplateColumns: "2fr 1fr",
    gap: theme.spacing(1),
    paddingRight: "90px",
    // for navigation buttons with absolute positioning
    marginTop: theme.spacing(1)
  },
  multiStepDatePicker: {
    padding: theme.spacing(1.5)
  },
  multiStepDatePickerListContainer: {
    padding: theme.spacing(1.5, 0),
    maxHeight: "400px",
    overflowY: "auto"
  }
}));
function MultiStepFilterDatePickerInitialStep({ value, onNextStep }) {
  const { value: dateRangeValue } = useDateRangeFilter({ value, onChange: null });
  return /* @__PURE__ */ React.createElement(
    MultiStepFilterInput,
    {
      label: localized.label,
      inputPlaceholder: localized.placeholder,
      inputValue: formatDateRange(dateRangeValue.from, dateRangeValue.to),
      onClick: () => onNextStep(
        1
        /* MultiStepFilterDatePickerStep */
      )
    }
  );
}
function getDefaultDate(state, value) {
  return state?.defaultDate ?? timestampSecondsToDate(value?.from) ?? getTodayAsDate();
}
function CaptionComponent({ defaultState, onNextStep }) {
  const { classes } = useClasses();
  const { monthsOptions } = useYearsAndMonthsOptions({
    disableFutureDates: true
  });
  return /* @__PURE__ */ React.createElement("div", { className: classes.multiStepDatePickerCaption }, /* @__PURE__ */ React.createElement(
    MultiStepFilterInput,
    {
      inputPlaceholder: localized.month,
      inputValue: monthsOptions[defaultState ? defaultState.getMonth() : getTodayAsDate().getMonth()].label,
      onClick: () => onNextStep(
        2
        /* MultiStepFilterDatePickerMonthStep */
      ),
      size: "small",
      background: "paper",
      inline: true
    }
  ), /* @__PURE__ */ React.createElement(
    MultiStepFilterInput,
    {
      inputPlaceholder: localized.year,
      inputValue: defaultState ? defaultState.getFullYear().toString() : getTodayAsDate().getFullYear().toString(),
      onClick: () => onNextStep(
        3
        /* MultiStepFilterDatePickerYearStep */
      ),
      size: "small",
      background: "paper",
      inline: true
    }
  ));
}
function MultiStepFilterDatePickerStep({ value, defaultState, onChange, onApply, onNextStep }) {
  const { classes } = useClasses();
  const [draftDateRange, setDraftDateRange] = useState(value);
  const {
    value: dateRangeValue,
    handleChange,
    availableRangeForSelection
  } = useDateRangeFilter({ value, onChange: (v) => setDraftDateRange(v) }, defaultState.availableDateRangeForSelection);
  const { defaultDate, locale, rangeMode } = defaultState;
  function handleApply() {
    onChange(draftDateRange);
    onApply();
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: classes.multiStepDatePicker }, /* @__PURE__ */ React.createElement(
    DateRangePicker,
    {
      captionComponent: ({ date }) => /* @__PURE__ */ React.createElement(CaptionComponent, { defaultState: date ?? getTodayAsDate(), onNextStep }),
      displayMode: "mobile",
      onSelect: handleChange,
      onChange: handleApply,
      selectedMonth: defaultDate ?? dateRangeValue?.from,
      value: dateRangeValue,
      type: "small",
      rangeMode,
      locale,
      disableFutureDates: true,
      placeholder: localized.placeholder,
      availableDateRangeForSelection: availableRangeForSelection
    }
  )), /* @__PURE__ */ React.createElement(MultiStepFilterApplyButton, { onApply: handleApply }));
}
function MultiStepFilterDatePickerMonthStep({
  value,
  defaultState,
  isStepActive,
  onStateChange,
  onApply
}) {
  const { classes } = useClasses();
  const [draftDate, setDraftDate] = useState(getDefaultDate(defaultState, value));
  const { monthsOptions } = useYearsAndMonthsOptions({
    disableFutureDates: true
  });
  function handleDateChange(e) {
    const newMonth = Number(e.target.value);
    const date = getDefaultDate(defaultState, value);
    const newDate = new Date(date?.getFullYear(), newMonth);
    setDraftDate(newDate);
  }
  function handleApply() {
    onStateChange({ ...defaultState, defaultDate: draftDate });
    onApply();
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: classes.multiStepDatePickerListContainer }, /* @__PURE__ */ React.createElement(
    RadioGroupList,
    {
      value: draftDate.getMonth(),
      options: monthsOptions,
      scrollToSelected: isStepActive,
      onChange: handleDateChange
    }
  )), /* @__PURE__ */ React.createElement(MultiStepFilterApplyButton, { onApply: handleApply }));
}
function MultiStepFilterDatePickerYearStep({
  value,
  defaultState,
  isStepActive,
  onStateChange,
  onApply
}) {
  const { classes } = useClasses();
  const [draftDate, setDraftDate] = useState(getDefaultDate(defaultState, value));
  const { yearsOptions } = useYearsAndMonthsOptions({
    disableFutureDates: true
  });
  function handleDateChange(e) {
    const newYear = Number(e.target.value);
    const date = getDefaultDate(defaultState, value);
    const newDate = new Date(newYear, date.getMonth());
    setDraftDate(newDate);
  }
  function handleApply() {
    onStateChange({ ...defaultState, defaultDate: draftDate });
    onApply();
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: classes.multiStepDatePickerListContainer }, /* @__PURE__ */ React.createElement(
    RadioGroupList,
    {
      value: draftDate.getFullYear(),
      options: yearsOptions,
      scrollToSelected: isStepActive,
      onChange: handleDateChange
    }
  )), /* @__PURE__ */ React.createElement(MultiStepFilterApplyButton, { onApply: handleApply }));
}
const MultiStepFilterDatePicker = withMultiStepFilterHoc(
  [
    MultiStepFilterDatePickerInitialStep,
    MultiStepFilterDatePickerStep,
    MultiStepFilterDatePickerMonthStep,
    MultiStepFilterDatePickerYearStep
  ],
  localized.label
);
export {
  MultiStepFilterDatePicker
};
//# sourceMappingURL=MultiStepFilterDatePicker.js.map
